(function() {
  function getCurrentVariant(form) {
    if (!form) {
      return null;
    }

    var currentVariantJson = form.querySelector('[data-current-variant-json]');

    if (currentVariantJson) {
      try {
        return JSON.parse(currentVariantJson.textContent);
      } catch (error) {
        return null;
      }
    }

    var variantJson = form.querySelector('[data-variant-json]');
    var variantId = form.querySelector('[name="id"]');

    if (!variantJson || !variantId) {
      return null;
    }

    try {
      var variants = JSON.parse(variantJson.textContent);

      return variants.find(function(variant) {
        return String(variant.id) === String(variantId.value);
      }) || variants[0] || null;
    } catch (error) {
      return null;
    }
  }

  function getTextContent(node) {
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function getVariantSummary(variant, quantity) {
    var parts = [];

    if (variant && variant.title && variant.title !== 'Default Title') {
      parts.push(variant.title);
    }

    if (quantity > 1) {
      parts.push('Qty ' + quantity);
    }

    return parts.join(' - ');
  }

  function syncSticky(form, sticky) {
    var section = form.closest('.product-section');
    var mainButton = form.querySelector('[data-add-to-cart]');
    var addToCartText = form.querySelector('[data-add-to-cart-text]');
    var stickyButton = sticky.querySelector('[data-main-product-sticky-button]');
    var stickyLabel = sticky.querySelector('[data-main-product-sticky-label]');
    var stickyTitle = sticky.querySelector('[data-main-product-sticky-title]');
    var stickySummary = sticky.querySelector('[data-main-product-sticky-summary]');
    var quantityInput = form.querySelector('input[name="quantity"]');
    var quantity = parseInt(quantityInput && quantityInput.value, 10);
    var variant = getCurrentVariant(form);
    var label = getTextContent(addToCartText);
    var summary = getVariantSummary(variant, Number.isFinite(quantity) && quantity > 0 ? quantity : 1);

    if (!label && addToCartText && addToCartText.dataset.defaultText) {
      label = addToCartText.dataset.defaultText;
    }

    if (stickyTitle && section && section.dataset.productTitle) {
      stickyTitle.textContent = section.dataset.productTitle;
    }

    if (stickySummary) {
      stickySummary.textContent = summary;
      stickySummary.hidden = !summary;
    }

    if (stickyLabel) {
      stickyLabel.textContent = label || 'ADD TO CART';
    }

    if (stickyButton) {
      var isDisabled = !mainButton || mainButton.disabled;

      stickyButton.disabled = isDisabled;
      stickyButton.classList.toggle('is-disabled', isDisabled);
    }
  }

  function initSticky(form) {
    var sticky = form.querySelector('[data-main-product-sticky-atc]');

    if (!sticky || sticky.dataset.initialized === 'true') {
      return;
    }

    sticky.dataset.initialized = 'true';

    var section = form.closest('.product-section');
    var mainButton = form.querySelector('[data-add-to-cart]');
    var stickyButton = sticky.querySelector('[data-main-product-sticky-button]');
    var addToCartText = form.querySelector('[data-add-to-cart-text]');

    if (!mainButton || !stickyButton) {
      return;
    }

    function setVisibility(isVisible) {
      sticky.classList.toggle('is-visible', isVisible);
    }

    function updateSticky() {
      syncSticky(form, sticky);
    }

    stickyButton.addEventListener('click', function() {
      if (!mainButton.disabled) {
        mainButton.click();
      }
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function(entries) {
          entries.forEach(function(entry) {
            setVisibility(!entry.isIntersecting);
          });
        },
        {
          threshold: 0.2
        }
      );

      observer.observe(mainButton);
    } else {
      var onScroll = function() {
        var rect = mainButton.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var isVisible = rect.top < viewportHeight && rect.bottom > 0;

        setVisibility(!isVisible);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    if (section) {
      section.addEventListener('variantChange', updateSticky);
    }

    form.addEventListener('change', updateSticky);
    form.addEventListener('input', updateSticky);

    [addToCartText].forEach(function(node) {
      if (!node) {
        return;
      }

      var observer = new MutationObserver(updateSticky);
      observer.observe(node, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true
      });
    });

    updateSticky();
  }

  function initAll(container) {
    (container || document).querySelectorAll('.product-single__form').forEach(function(form) {
      initSticky(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();